import * as React from 'react';
import styles from './index.module.scss';

const Footer = () => {
  const [hidden, setHidden] = React.useState(false);

  React.useEffect(() => {
    const timer = window.setTimeout(() => {
      setHidden(true);
    }, 3000);

    return () => {
      window.clearTimeout(timer);
    };
  }, []);

  if (hidden) {
    return null;
  }

  return (
    <footer className={styles.footer}>
      <a target="_blank" rel="noreferrer" href="https://beian.miit.gov.cn/">
        蜀ICP备2022007945号-1
      </a>
    </footer>
  );
};

export default Footer;
